angular.module('TurneroApp').component('coLogin', {
    controller: [
        '$window',
        'loginService',        
        '$stateParams',
        'loginErrorService',
        function ($window, loginService, $stateParams, loginErrorService) {
            var ctrl = this;
       
            ctrl.$onInit = function () {
                //se setean los valores por defecto.
                ctrl.usuario = ""
                ctrl.clave = ""
                ctrl.setSesionId($stateParams.sesionid);
            }

            ctrl.setSesionId = function (sesionId) {
                loginService.setSesionId({
                    'sesionid': sesionId
                }).$promise.then(function (result) {
                    if (result && result.Url) {
                        return loginService.Post_Usuario_VeDi().$promise.then(function (data)
                        {    
                            $window.location.href = result.Url;
                        });
                    }else{
                        mostrarError();
                    }
                }).catch(mostrarError);
            }

            ctrl.iniciarSesion = function () {
                loginService.Login({
                    'usuario': ctrl.usuario,
                    'clave': ctrl.clave
                }).$promise.then(function (result) {
                    if (result && result.Url) {
                        $window.location.href = result.Url;   
                    }else{
                        mostrarError();
                    }
                }).catch(mostrarError);
            };

            function mostrarError(error) {
                ctrl.errorInicioSesion = loginErrorService.mostrar(error);
            }
            
        }
    ],
    template: require('./login.html')
});



// WEBPACK FOOTER //
// ./app/components/login/loginComponent.js